import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Auth from "./Auth";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Auth />
  </React.StrictMode>
);
